import FileDropCard from './FileDropCard';

import FinalFileCard from './FinalFileCard';
import FileDropProcessing from './Processing';
import useFileDrop from './useFileDrop';

export interface FileDropProps {
  name: string;
  isSubmitting?: boolean;
}

const FileDrop: React.FunctionComponent<FileDropProps> = function ({
  name,
  isSubmitting = false,
}) {
  const {
    classNames,
    onDragOver,
    onDragLeave,
    onDrop,
    onInputClick,
    onInputChange,
    dragOverError,
    finalFile,
    show,
    removeFile,
  } = useFileDrop(name, isSubmitting);
  return (
    <div className="flex flex-col">
      {show === 'card' && (
        <FileDropCard
          classNames={classNames}
          onDragOver={onDragOver}
          onDragLeave={onDragLeave}
          onDrop={onDrop}
          onInputClick={onInputClick}
          onInputChange={onInputChange}
          name={name}
        />
      )}
      {show === 'processing' && (
        <FileDropProcessing className={classNames.processing} />
      )}
      {show === 'file' && finalFile && (
        <FinalFileCard file={finalFile} removeFile={removeFile} />
      )}
      {dragOverError && <p className={classNames.error}>{dragOverError}</p>}
    </div>
  );
};

export default FileDrop;
